import SuggestedSearches from '../NoSourcesFoundComponent/components/SuggestedSearches';
import Card from '../components/Card';

interface RelatedSearchesProps {
  suggestedSearches: string[];
}

const RelatedSearches = ({ suggestedSearches }: RelatedSearchesProps) => {
  if (!suggestedSearches.length) return null;

  return (
    <Card
      sx={{
        paddingX: { mobile: '16px', tablet: '30px', desktop: '30px' },
        paddingTop: { desktop: '8px', tablet: '8px', mobile: '8px' },
        paddingBottom: { mobile: '16px', tablet: '24px', desktop: '24px' },
      }}
    >
      <SuggestedSearches suggestedSearchesData={suggestedSearches} title="Related searches:" />
    </Card>
  );
};

export default RelatedSearches;
